import * as core from '../../../../../../../core'

import { query } from './outcome-explore-metrics.query'

export const RESOURCE = {
  payload: {
    alias: 'summit.outcome-explore-metrics',
    description:
      'Displays Metrics information about the currently focused outcome, if there is one',
    name: 'Summit - Outcome Explore Metrics',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
